import type { Product } from "@jti/magento";

export const hasRestrictedSkusForPayOnDelivery = (
  restrictedSkusAsString: string,
  orderItems: Pick<Product, "sku">[]
) => {
  if (!restrictedSkusAsString || !orderItems || orderItems.length === 0) {
    return false;
  }

  const restrictedSkusSet = new Set(restrictedSkusAsString.split(",").map((sku) => sku.trim()));

  const isRestrictedItemInOrder = orderItems.some((item) => restrictedSkusSet.has(item.sku));

  return isRestrictedItemInOrder;
};
